/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState, useMemo } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import profile from "assets/images/profile.png";
import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  Icon,
  IconButton,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import debounce from "lodash.debounce";
import { getAllUsers } from "api";
import { updateUserProfile } from "api";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { exportToExcel } from "utilities";
import { getIndustries } from "api";
import { getCities } from "api";
import { getJobType } from "api";

export default function data({ isMyProfile = true }) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [skip, setSkip] = useState();
  const limit = 20;
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [skill, setSkill] = useState("");

  const [pdfUrl, setPdfUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const [arrIndustry, setArrIndustry] = useState([{ _id: "all", name: "All" }]);
  const [industry, setIndustry] = useState(arrIndustry[0]);

  const [arrJobType, setArrJobType] = useState([{ name: "All" }]);
  const [jobType, setJobType] = useState(arrJobType[0]);

  const [arrLocation, setArrLocation] = useState([{ name: "All" }]);
  const [location, setLocation] = useState(arrLocation[0]);

  useEffect(() => {
    onSearchData("");

    getIndustriesApi();
    getLocationApi();
    getJobTypeApi();
  }, []);

  useEffect(() => {
    if (search !== undefined) {
      if (skip === 0) {
        getAllUsersApi();
      } else {
        setSkip(0);
      }
    }
  }, [search]);

  useEffect(() => {
    if (skip !== undefined) {
      getAllUsersApi();
    }
  }, [skip]);

  const debouncedFetch = useRef(
    debounce((searchVal) => {
      setSearch(searchVal);
    }, 500)
  ).current;

  const getAllUsersApi = (isReset = false) => {
    var params = {
      skip: skip,
      limit: limit,
      name: search,
    };

    if (isReset) {
      params.industry = "all";
      params.location = "all";
      params.jobType = "all";
      params.skill = "";
    } else {
      params.industry = industry?._id || "all";
      params.location = location?.name || "all";
      params.jobType = jobType?._id || "all";
      params.skill = skill;
    }

    setLoading(true);

    getAllUsers({
      params: params,
    })
      .then((responseJson) => {
        if (skip === 0) {
          setList(responseJson?.employee);
        } else {
          setList([...list, ...responseJson?.employee]);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getIndustriesApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      type: "all",
    };

    getIndustries({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrIndustry([...arrIndustry, ...responseJson?.industry]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const getJobTypeApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      type: "all",
    };
    getJobType({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrJobType([...arrJobType, ...responseJson?.jobType]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const getLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getCities({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrLocation([...arrLocation, ...responseJson?.cities]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const onSearchData = (val) => {
    debouncedFetch(val);
  };

  const Applicant = ({ name, image, totalExperience, location }) => {
    const imgWidth = image ? "100%" : "50%";
    const imgHeight = image ? "100%" : "50%";
    const imgResize = image ? "cover" : "contain";

    return (
      <MDBox display="flex" gap={2}>
        <MDAvatar
          src={image || profile}
          size="sm"
          sx={{
            width: "45px", // optional: control size
            height: "45px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography display="block" variant="button" fontWeight="medium" noWrap>
            {name}
          </MDTypography>

          <MDTypography
            variant="caption"
            display="block"
            noWrap
            sx={{
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {location}
          </MDTypography>

          <MDTypography
            variant="caption"
            noWrap
            sx={{
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {totalExperience}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const columns = () => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      // { Header: "contact details", accessor: "contact", align: "left" },
      { Header: "industry", accessor: "industry", align: "left" },
      { Header: "job type", accessor: "jobType", align: "left" },
      { Header: "skill", accessor: "skill", align: "left" },
      { Header: "registered on", accessor: "applied", align: "center" },

      // { Header: "status", accessor: "status", align: "center" },

      { Header: "resume", accessor: "resume", align: "center" },
      {
        Header: "action",
        accessor: "action",
        align: "center",
      },
    ];
  };

  const handleStatus = (user) => {
    var params = {
      isActive: user?.isActive ? false : true,
      id: user?._id,
    };
    updateUserApi(params);

    // const updatedUsers = list.map((u) => (u._id === user.id ? { ...u, isActive: !u.isActive } : u));
    // setList(updatedUsers);
  };

  const rows = () => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <Applicant
            name={`${item?.firstName || ""} ${item?.lastName || ""}`}
            image={item?.profileURL}
            totalExperience={item?.totalExperience}
            location={item?.locations?.join(", ")}
          />
        ),
        // contact: (
        //   <MDBox sx={{ px: 1 }}>
        //     <MDTypography display="block" variant="caption">
        //       {`${item?.code} ${item?.phone}`}
        //     </MDTypography>
        //     <MDTypography variant="caption">{item?.email}</MDTypography>
        //   </MDBox>
        // ),
        industry: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption">
              {item?.industry.map((item) => item?.name).join(", ")}
            </MDTypography>
          </MDBox>
        ),
        jobType: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption">
              {item?.jobType.map((item) => item?.name).join(", ")}
            </MDTypography>
          </MDBox>
        ),
        skill: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption">{item?.skills?.join(", ")}</MDTypography>
          </MDBox>
        ),

        applied: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption" noWrap>{`${moment(item?.createdAt).format(
              "DD MMM YYYY"
            )}`}</MDTypography>
          </MDBox>
        ),
        // status: (
        //   <MDBox>
        //     <Switch checked={item?.isActive} onChange={() => handleStatus(item)} color="success" />
        //   </MDBox>
        // ),
        resume: (
          <MDBox sx={{ px: 2 }} onClick={() => handleResume(item)}>
            {item?.documentURL && (
              <MDTypography
                component="a"
                variant="caption"
                color="secondary"
                fontWeight="medium"
                sx={{ cursor: "pointer" }}
              >
                <Icon fontSize="small">article_outlined</Icon>
              </MDTypography>
            )}
          </MDBox>
        ),
        action: (
          <MDBox sx={{ px: 2 }} onClick={() => handleProfile(item)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">arrow_forward</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  };

  const handleProfile = (item) => {
    navigate("/profile/profile-detail", { state: { user: item } });
  };

  const handleResume = async (item) => {
    if (item?.documentURL) {
      setPdfUrl(item?.documentURL);
      setOpenPreview(true);
    }
  };

  const updateUserApi = (params) => {
    updateUserProfile({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            if (skip === 0) {
              getAllUsersApi();
            } else {
              setSkip(0);
            }
          }
        }
      })
      .catch((e) => {});
  };

  const pdfViewer = () => {
    return (
      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} fullWidth maxWidth="lg">
        <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6">PDF Preview</MDTypography>
          <IconButton onClick={() => setOpenPreview(false)}>
            <CloseIcon />
          </IconButton>
        </MDBox>
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfUrl)}&embedded=true`}
          style={{ width: "100%", height: "80vh", border: "none" }}
          title="PDF Viewer"
        />
      </Dialog>
    );
  };

  const handleApplyFilter = () => {
    getAllUsersApi();
  };
  const handleResetFilter = () => {
    // setStatus(arrStatus[0]);
    setJobType(arrJobType[0]);
    setLocation(arrLocation[0]);
    setIndustry(arrIndustry[0]);
    setSkill("");

    getAllUsersApi(true);
  };

  const handleExport = () => {
    exportToExcel(list, "employee.xlsx");
  };

  const ViewFilter = useMemo(() => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Industry"
              value={JSON.stringify(industry)}
              onChange={(e) => setIndustry(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrIndustry.map((item) => (
                <MenuItem key={item?._id} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Location"
              value={JSON.stringify(location)}
              onChange={(e) => setLocation(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrLocation.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Job Type"
              value={JSON.stringify(jobType)}
              onChange={(e) => setJobType(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrJobType.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              label="Skill"
              value={skill}
              onChange={(e) => setSkill(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            >
              {/* {arrStatus.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))} */}
            </MDInput>
          </MDBox>
        </MDBox>

        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} color="success">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  }, [
    industry,
    arrIndustry,
    location,
    arrLocation,
    jobType,
    arrJobType,
    skill,
    handleApplyFilter,
    handleResetFilter,
    handleExport,
  ]);

  return (
    <MDBox>
      {/* <ViewFilter /> */}
      {ViewFilter}
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns: columns(), rows: rows() }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            noEndBorder
            onSearch={(val) => {
              onSearchData(val);
            }}
          />

          {pdfViewer()}

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="success" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
